import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import type { Issue } from '../api/types';
import { IssueRow } from '../components/IssueRow';
import { ScreenshotDrop } from '../components/ScreenshotDrop';
import type { UploadResult } from '../api/storage';

export function IntakePage() {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [recent, setRecent] = useState<Issue[]>([]);
  const [listError, setListError] = useState('');
  const [screenshot, setScreenshot] = useState<UploadResult | null>(null);

  useEffect(() => {
    api
      .list({ limit: 8 })
      .then((r) => {
        setRecent(r.items);
        setListError('');
      })
      .catch((e) => {
        setListError(e instanceof Error ? e.message : 'List fehlgeschlagen');
      });
  }, []);

  async function submit() {
    if (!text.trim() || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      const res = await api.intake(text.trim(), screenshot?.id);
      navigate(`/i/${res.id}`);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Submit fehlgeschlagen');
      setSubmitting(false);
    }
  }

  return (
    <>
      <div className="page-header">
        <h2>Intake</h2>
        <span className="breadcrumb">freier text · ki-klassifiziert</span>
      </div>

      <section className="intake-card">
        <label htmlFor="intake-text">Was ist los?</label>
        <textarea
          id="intake-text"
          autoFocus
          placeholder="Beschreibe den Bug, das Problem oder den Wunsch — freier Text. Die KI extrahiert Titel, Severity, Component, Tags automatisch."
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) submit();
          }}
          disabled={submitting}
        />
        <div className="intake-actions">
          <ScreenshotDrop onUploaded={setScreenshot} disabled={submitting} />
          <button className="primary" onClick={submit} disabled={!text.trim() || submitting}>
            {submitting ? (
              <>
                <span className="spinner" /> &nbsp; KI klassifiziert…
              </>
            ) : (
              'Senden ↵'
            )}
          </button>
        </div>
        <div className="intake-hint">⌘/Ctrl + Enter zum Senden</div>
        {error && <div className="error">{error}</div>}
      </section>

      <div className="page-header" style={{ marginTop: 8 }}>
        <h2>Zuletzt</h2>
        <span className="breadcrumb">{recent.length} issues</span>
      </div>

      {listError && <div className="error">{listError}</div>}
      {!listError && recent.length === 0 && (
        <div className="empty-state">noch keine issues — sei die*der erste</div>
      )}
      {recent.length > 0 && (
        <>
          <div className="issue-list">
            {recent.map((i) => (
              <IssueRow key={i.id} issue={i} />
            ))}
          </div>
          <div style={{ marginTop: 14, textAlign: 'right' }}>
            <Link to="/list" className="mono" style={{ fontSize: 11, letterSpacing: 1, textTransform: 'uppercase' }}>
              alle anzeigen →
            </Link>
          </div>
        </>
      )}
    </>
  );
}
